import { UploadProgressState } from '../../../../store/domain/filesUploadProgress/filesUploadProgress.model'
import { useDispatch } from 'react-redux'
import { FC, useEffect, useState } from 'react'
import { resetUpload } from '../../../../store/domain/filesUploadProgress/filesUploadProgress.actions'
import {
  FileUploadIndicator
} from '@follow-health/fw_ui_library/dist/features/app/features/MedicalEvents/components/FileUploadIndicator'

export const UploadProgressBarContainer: FC<UploadProgressState> = (progress: UploadProgressState ) =>{
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    if (progress && (progress.status === 'done' || progress.status === 'error')) {
      const t = setTimeout(() => {
        setVisible(false)
        dispatch(resetUpload()) // back to idle (so it unmounts cleanly)
      }, 1500)
      return () => clearTimeout(t)
    }
    setVisible(true)
  }, [progress, dispatch])

  if (!visible || progress?.status === 'idle') return null
  return progress && <FileUploadIndicator progress={progress} />
}
